module.exports = __webpack_public_path__ + "static/media/group@2x.7901bd7c.jpg";